import { axios } from '@/utils/request'

export function fetchList (params) {
  return axios({
    url: '/sxWorkerType/page',
    method: 'GET',
    params: {
      ...params
    }
  })
}

export function delObj (id) {
  return axios({
    url: `/sxWorkerType/${id}`,
    method: 'DELETE'
  })
}
export function getObj (id) {
  return axios({
    url: `/sxWorkerType/${id}`,
    method: 'GET'
  })
}
export function addObj (params) {
  return axios({
    url: `/sxWorkerType/save`,
    method: 'POST',
    data: {
      ...params
    }
  })
}
export function putObj (params) {
  return axios({
    url: `/sxWorkerType/update`,
    method: 'POST',
    data: {
      ...params
    }
  })
}
